import React, { Fragment } from "react"
import {
    Card,
    CardBody,
    Col,
    Row
} from "reactstrap";
import moment from "moment";

class CoBorrowers extends React.Component {

    render() {
        
        const {
            client
        } = this.props;

        return (
            <Card>
              <CardBody>
                {client.coBorrowers &&
                client.coBorrowers.length > 0 ? (
                  client.coBorrowers.map(
                    (
                      { coBorrower, coBorrowerOccupation },
                      index
                    ) => {
                      return (
                        <Fragment key={index}>
                          <h4>CoBorrower #{index + 1}</h4>
                          <Row>
                            <Col sm="6">
                              <div className="typography-line">
                                <h4>
                                  <span>First Name</span>
                                  {coBorrower.first_name ||
                                    "N/A"}
                                </h4>
                              </div>
                            </Col>
                            <Col sm="6">
                              <div className="typography-line">
                                <h4>
                                  <span>Last Name</span>
                                  {coBorrower.last_name ||
                                    "N/A"}
                                </h4>
                              </div>
                            </Col>
                            <Col sm="6">
                              <div className="typography-line">
                                <h4>
                                  <span>Middle Name</span>
                                  {coBorrower.middle_name ||
                                    "N/A"}
                                </h4>
                              </div>
                            </Col>
                            <Col sm="6">
                              <div className="typography-line">
                                <h4>
                                  <span>Email</span>
                                  {coBorrower.email || "N/A"}
                                </h4>
                              </div>
                            </Col>
                            <Col sm="6">
                              <div className="typography-line">
                                <h4>
                                  <span>Gender</span>
                                  {coBorrower.gender || "N/A"}
                                </h4>
                              </div>
                            </Col>
                            <Col sm="6">
                              <div className="typography-line">
                                <h4>
                                  <span>Nationality</span>
                                  {coBorrower.nationality ||
                                    "N/A"}
                                </h4>
                              </div>
                            </Col>
                            <Col sm="6">
                              <div className="typography-line">
                                <h4>
                                  <span>Birthday</span>
                                  {(coBorrower.birthday &&
                                    moment(
                                      coBorrower.birthday
                                    ).format("MM/DD/YYYY")) ||
                                    "N/A"}
                                </h4>
                              </div>
                            </Col>
                            <Col sm="6">
                              <div className="typography-line">
                                <h4>
                                  <span>Age</span>
                                  {coBorrower.age || "N/A"}
                                </h4>
                              </div>
                            </Col>
                            <Col sm="6">
                              <div className="typography-line">
                                <h4>
                                  <span>Address</span>
                                  {coBorrower.address ||
                                    "N/A"}
                                </h4>
                              </div>
                            </Col>
                            <Col sm="6">
                              <div className="typography-line">
                                <h4>
                                  <span>Phone</span>
                                  {coBorrower.phone || "N/A"}
                                </h4>
                              </div>
                            </Col>
                            <Col sm="6">
                              <div className="typography-line">
                                <h4>
                                  <span>Occupation</span>
                                  {coBorrower.occupation ||
                                    "N/A"}
                                </h4>
                              </div>
                            </Col>
                            <Col sm="6">
                              <div className="typography-line">
                                <h4>
                                  <span>Company Name</span>
                                  {coBorrower.companyName ||
                                    "N/A"}
                                </h4>
                              </div>
                            </Col>
                            <Col sm="6">
                              <div className="typography-line">
                                <h4>
                                  <span>Business Nature</span>
                                  {coBorrower.businessNature ||
                                    "N/A"}
                                </h4>
                              </div>
                            </Col>
                            <Col sm="6">
                              <div className="typography-line">
                                <h4>
                                  <span>Company Address</span>
                                  {coBorrower.companyAddress ||
                                    "N/A"}
                                </h4>
                              </div>
                            </Col>
                            <Col sm="6">
                              <div className="typography-line">
                                <h4>
                                  <span>Company Contact</span>
                                  {coBorrower.companyContact ||
                                    "N/A"}
                                </h4>
                              </div>
                            </Col>
                            <Col sm="6">
                              <div className="typography-line">
                                <h4>
                                  <span>Company Email</span>
                                  {coBorrower.companyEmail ||
                                    "N/A"}
                                </h4>
                              </div>
                            </Col>
                            <Col sm="6">
                              <div className="typography-line">
                                <h4>
                                  <span>Experience</span>
                                  {coBorrower.experience ||
                                    "N/A"}
                                </h4>
                              </div>
                            </Col>
                            <Col sm="6">
                              <div className="typography-line">
                                <h4>
                                  <span>Job Title</span>
                                  {coBorrower.jobTitle ||
                                    "N/A"}
                                </h4>
                              </div>
                            </Col>
                          </Row>
                        </Fragment>
                      );
                    }
                  )
                ) : (
                  <div className="typography-line">
                    <h4>
                      <span>N/A</span>
                    </h4>
                  </div>
                )}
              </CardBody>
            </Card>
        )
    }
}

export default CoBorrowers;